import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
    HoverCard,
    HoverCardContent,
    HoverCardTrigger,
} from "@/components/ui/hover-card";
import { Label } from "@/components/ui/label";
import { IconCirclesRelation, IconArrowRight } from "@tabler/icons-react";

interface Props {
    title: string;
    subtitle?: string;
    icon?: React.ReactNode;
    color?: string;
    children?: React.ReactNode;
    WIP?: boolean;
    WIPMessage?: string;
}
export default function PageHeading({
    title,
    subtitle,
    icon,
    color,
    children,
    WIP,
    WIPMessage,
}: Props) {
    const shouldRenderPlain = !icon && !color;

    if (shouldRenderPlain) {
        return (
            <div className="flex items-start justify-between gap-3">
                <div className="flex flex-col gap-0">
                    <div className="flex items-center gap-3">
                        <Label variant="pageHeading">{title}</Label>
                        {WIP && (
                            <HoverCard openDelay={0}>
                                <HoverCardTrigger asChild>
                                    <Badge
                                        variant={"outline"}
                                        className="cursor-pointer !border !border-primary"
                                    >
                                        WIP
                                    </Badge>
                                </HoverCardTrigger>
                                <HoverCardContent className="border-primary px-3 py-2 text-xs">
                                    {WIPMessage ? (
                                        WIPMessage
                                    ) : (
                                        <span>
                                            This feature or page is still in
                                            development with further updates
                                            planned.
                                        </span>
                                    )}
                                </HoverCardContent>
                            </HoverCard>
                        )}
                    </div>
                    {subtitle && <Label variant="subtoggle">{subtitle}</Label>}
                </div>
                {children}
            </div>
        );
    }
    return (
        <Card className="relative flex w-full flex-col md:flex-row md:items-center">
            <CardHeader className="w-full p-2 pb-2">
                <CardTitle className="flex items-center gap-2">
                    {icon && (
                        <div
                            className={`rounded-md ${color ? `bg-${color}` : "bg-secondary"} p-2`}
                        >
                            {icon}
                        </div>
                    )}
                    <div className="flex h-fit flex-col">
                        <div className="flex items-center gap-3">
                            <Label variant="pageHeading">{title}</Label>
                            {WIP && (
                                <HoverCard openDelay={0}>
                                    <HoverCardTrigger asChild>
                                        <Badge
                                            className={`cursor-pointer ${color !== null && color !== "transparent" ? `bg-${color} hover:bg-${color}/80` : "border-border bg-transparent"}`}
                                        >
                                            WIP
                                        </Badge>
                                    </HoverCardTrigger>
                                    <HoverCardContent
                                        className={`${color ? `border-${color}` : "border-primary"} px-3 py-2 text-xs`}
                                    >
                                        This feature or page is still in
                                        development with further updates
                                        planned.
                                    </HoverCardContent>
                                </HoverCard>
                            )}
                        </div>
                        {subtitle && <Label variant="toggle">{subtitle}</Label>}
                    </div>
                </CardTitle>
            </CardHeader>
            {children && <CardContent className="p-3">{children}</CardContent>}
        </Card>
    );
}
